import { z } from 'zod';

import { AbstractMeasurement } from './AbstractMeasurement';

const units = ['uH/m', 'uH/km', 'uH/ft', 'mH/m', 'mH/km', 'mH/ft', 'H/m', 'H/km', 'H/ft'] as const;
const unit = z.enum(units).default('H/m');

const validator = AbstractMeasurement.value
    .extend({
        unit,
    })
    .default({});

export const InductancePerUnitLength = {
    validator,
    units,
    unit,
};

export type InductancePerUnitLength = z.infer<typeof validator>;
